import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'lib-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.scss',
})
export class TextEditorComponent {
  @Input() label?: string;
  @Input() textHint?: string;
  @Input() formGroup!: FormGroup;
  @Input() textFormControlName!: string;
  @Input() fontSizeFormControlName?: string;
  @Input() fontColorFormControlName?: string;
  @Input() multiline = false;
  @Input() fullWidth = false;
  @Input() compactColorPicker = false;
}
